import styles from "./Consulting.module.css";
import SubPageTop from "../components/SubPageTop";
import { useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import ScrollReveal from "../components/Ui/ScrollReveal";

const TABS = [
    { label: "기업 컨설팅", value: "enterprise" },
    { label: "개인 컨설팅", value: "personal" },
];

const ENTERPRISE_LINKS = [
    { 
        label: "환경 컬러", 
        path: "/consulting/enterprise-environment",
        description: "건축, 건설, 인테리어, 조경 컨셉에 따른 컬러 제안"
    },
    {
        label: "제품 컬러", 
        path: "/consulting/enterprise-product",
        description: "제품, 포장, 패키지, 푸드 컬러 팔레트 제안"
    },
    { 
        label: "브랜드 아이덴티티", 
        path: "/consulting/enterprise-brand-identity",
        description: "브랜드 메인 컬러 선정 BL & CL 등 로고 컬러 선정"
    },
    { 
        label: "그래픽 컬러", 
        path: "/consulting/enterprise-graphic",
        description: "영상, 광고(CF, 전단), 방송 등 그래픽 컬러 팔레트 제안"
    },
    { 
        label: "뷰티 컬러", 
        path: "/consulting/enterprise-beauty",
        description: "패션, 메이크업, 헤어컬러 디자인 및 제품 컬러 선정"
    },
];

const PERSONAL_LINKS = [
    { 
        label: "퍼스널 컬러", 
        path: "/consulting/personal-color",
        description: "자신이 가진 신체 색과 조화를 이루어 패션, 메이크업 등에 도움을 줄 만한 어울리는 컬러를 찾는 프로그램"
    },
    { 
        label: "컬러 테라피", 
        path: "/consulting/personal-therapy",
        description: "업무, 학업, 가정, 관계 등 일상의 스트레스 치유 & 힐링과 심신의 균형을 맞추기 위한 컬러 힐링 프로그램"
    },
    { 
        label: "이미지 컨설팅", 
        path: "/consulting/personal-image",
        description: "직업 및 성향에 따라 개인의 이미지를 분석하고 컬러, 패션스타일, 헤어, 메이크업 스타일을 제안하는 토탈 컨설팅 프로그램"
    },
    { 
        label: "퍼스널 브랜딩", 
        path: "/consulting/personal-branding",
        description: "개인의 꿈, 가치관, 비전 등을 분석하여 목표를 정하고 해당하는 브랜딩 툴과 채널을 이용하여 개인의 가치 창출 및 관리"
    },
];

function Consulting() {
    const [tab, setTab] = useState(TABS[0].value);
    

    return (
        <div className={styles.consultingWrap}>
            <SubPageTop title="Consulting" subTitle="색채 컨설팅" backgroundColor="#F7A9C3" />
            <div className={styles.consultingContent}>
                <ScrollReveal>
                    <section className={styles.section01}>
                        <div className={styles.imgbox}>
                            <img
                                src="/image/business-meeting-with-colleagues-at-office.png"
                                alt="컬러 이미지"
                            />
                        </div>
                        <div className={styles.infoBox}>
                            <div className={styles.infoHeader}>
                                <p className={styles.subtitle}>
                                    Color Consulting
                                </p>
                                <p className={styles.koTitle}>
                                    색채 컨설팅
                                </p>
                            </div>
                            <div className={styles.infoDetail}>
                                <div className={styles.infoDesc}>
                                    <span>
                                        한국감성색채협회는 개인과 단체의 브랜드 경쟁력을 높이는 색채 컨설팅 및 교육을 진행하고 있습니다.
                                    </span>
                                    <span>
                                        환경, 제품, 그래픽, 뷰티 등 다양한 영역의 기업 컬러 브랜딩 컨설팅을 진행하고 있습니다. 퍼스널컬러, 컬러테라피, 이미지컨설팅 등 개인 브랜딩 컨설팅을 진행하고 있습니다.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </section>
                </ScrollReveal>
                <ScrollReveal>
                    <div className={styles.section02}>
                    <div className={styles.titleWrap}>
                        <p className={styles.programSubtitle}>
                            program
                        </p>
                        <h2 className={styles.title}>
                            컨설팅 프로그램
                        </h2>
                    </div>
                    <div className={styles.line}></div>
                    <div className={styles.contentWrap}>
                        <ul className={styles.tabList}>
                            {TABS.map((t) => (
                                <li
                                    key={t.value}
                                    className={`${styles.tabItem} ${
                                        tab === t.value ? styles.active : ""
                                    }`}
                                    onClick={() => setTab(t.value)}
                                >
                                    {t.label}
                                </li>
                            ))}
                        </ul>
                        <div className={styles.tabContent}>
                            {tab === "enterprise" && (
                                <div className={styles.tabContentInner}>
                                    <div className={styles.cardGrid}>
                                        {ENTERPRISE_LINKS.map((link, index) => (
                                            <Link 
                                                key={link.path} 
                                                to={link.path} 
                                                className={`${styles.cardItem} ${styles[`cardColor${(index % 3) + 1}`]}`}
                                            >
                                                <div className={styles.cardHeader}>
                                                    <h3 className={styles.cardTitle}>{link.label}</h3>
                                                </div>
                                                <p className={styles.cardDesc}>{link.description}</p>
                                                <div className={styles.cardFooter}>
                                                    <span className={styles.cardButton}>
                                                        상세히 알아보기
                                                        <FiArrowRight className={styles.cardButtonIcon} />
                                                    </span>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {tab === "personal" && (
                                <div className={styles.tabContentInner}>
                                    <div className={styles.cardGrid}>
                                        {PERSONAL_LINKS.map((link, index) => (
                                            <Link 
                                                key={link.path} 
                                                to={link.path} 
                                                className={`${styles.cardItem} ${styles[`cardColor${(index % 3) + 1}`]}`}
                                            >
                                                <div className={styles.cardHeader}>
                                                    <h3 className={styles.cardTitle}>{link.label}</h3>
                                                </div>
                                                <p className={styles.cardDesc}>{link.description}</p>
                                                <div className={styles.cardFooter}>
                                                    <span className={styles.cardButton}>
                                                        상세히 알아보기
                                                        <FiArrowRight className={styles.cardButtonIcon} />
                                                    </span>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                </ScrollReveal>
            </div>
        </div>
    );
}

export default Consulting;